export enum SupportedChurchVideoService {
  YOUTUBE = 'YOUTUBE',
  FACEBOOK = 'FACEBOOK'
}

export interface ChurchLink {
  name: string;
  url: string;
}

export interface Church {
  id: string
  attributes: {
    name: string
    location: string
    /**
     * The URL for the image used in Church Search
     */
    pictureUrl?: string
    givingUrl?: string
    links: ChurchLink[]
    timezone: string
    frozen: boolean
  }
}

export enum StaffRole {
  ADMIN = "Admin",
  VOLUNTEER_MANAGER = "Volunteer Manager",
  EVENT_MANAGER = "Event Manager",
  PLAYLIST_MANAGER = "Playlist Manager",
  SERVICE_MANAGER = "Service Manager",
  LAUNCHPAD_MANAGER = "Launchpad Manager",
  PEOPLE_MANAGER = "People Manager"
}

// The roles a staff member can be given.
export const allStaffRoles = [
  StaffRole.ADMIN,
  StaffRole.VOLUNTEER_MANAGER,
  StaffRole.EVENT_MANAGER,
  StaffRole.PLAYLIST_MANAGER,
  StaffRole.SERVICE_MANAGER,
  StaffRole.LAUNCHPAD_MANAGER,
  StaffRole.PEOPLE_MANAGER
]

export enum StaffAction {
  DELETE_STAFF_USER,
  CREATE_STAFF_USER,
  EDIT_STAFF_USER,
  EDIT_CHURCH_METADATA,
  CREATE_DAILY_DEVOTIONAL,

  CREATE_PLAYLIST,
  EDIT_PLAYLIST,
  DELETE_PLAYLIST,

  // Access to each area of Church Hub, which decides what the sidebar shows.
  MANAGE_LAUNCHPAD,
  MANAGE_PLAYLISTS,
  MANAGE_SERVICES,
  MANAGE_EVENTS,
  MANAGE_VOLUNTEERING,
  MANAGE_PEOPLE,
  MANAGE_STAFF,
  MANAGE_CONNECTIONS,
  MANAGE_SETTINGS
}

/**
 * This is where staff allowed/denied actions can be configured.
 */
export const permissionMap = {
  [StaffAction.DELETE_STAFF_USER]: [StaffRole.ADMIN],
  [StaffAction.EDIT_STAFF_USER]: [StaffRole.ADMIN],
  [StaffAction.CREATE_STAFF_USER]: [StaffRole.ADMIN],
  [StaffAction.EDIT_CHURCH_METADATA]: [StaffRole.ADMIN],
  [StaffAction.CREATE_DAILY_DEVOTIONAL]: [StaffRole.ADMIN],

  [StaffAction.CREATE_PLAYLIST]: [StaffRole.ADMIN, StaffRole.PLAYLIST_MANAGER],
  [StaffAction.EDIT_PLAYLIST]: [StaffRole.ADMIN, StaffRole.PLAYLIST_MANAGER],
  [StaffAction.DELETE_PLAYLIST]: [StaffRole.ADMIN, StaffRole.PLAYLIST_MANAGER],

  // Each manager role opens its own area; the legacy roles keep the areas
  // they already had.
  [StaffAction.MANAGE_LAUNCHPAD]: [StaffRole.ADMIN, StaffRole.LAUNCHPAD_MANAGER],
  [StaffAction.MANAGE_PLAYLISTS]: [StaffRole.ADMIN, StaffRole.PLAYLIST_MANAGER],
  [StaffAction.MANAGE_SERVICES]: [StaffRole.ADMIN, StaffRole.SERVICE_MANAGER],
  [StaffAction.MANAGE_EVENTS]: [StaffRole.ADMIN, StaffRole.EVENT_MANAGER],
  [StaffAction.MANAGE_VOLUNTEERING]: [StaffRole.ADMIN, StaffRole.VOLUNTEER_MANAGER],
  [StaffAction.MANAGE_PEOPLE]: [StaffRole.ADMIN, StaffRole.PEOPLE_MANAGER],
  [StaffAction.MANAGE_STAFF]: [StaffRole.ADMIN],
  [StaffAction.MANAGE_CONNECTIONS]: [StaffRole.ADMIN],
  [StaffAction.MANAGE_SETTINGS]: [StaffRole.ADMIN]
}

export interface ChurchStaff {
  id: string
  email: string
  name: string
  roles: StaffRole[]
}

export interface ChurchAssetUploadTarget {
  method: string;
  url: string;
  assetURL: string;
  fields: Record<string, string>;
  key: string;
  maxFileSizeBytes: number;
  contentType: string;
}

export interface ChurchMinistry {
  name: string
  subministries: string[]
}

export { }